/**
 * Experiment to add friction to sign up to deter bad actors
 * https:www.notion.so/faire/Sign-up-flow-good-friction-updates-d56a959b24484e22abc55a4eac8be758
 */
export const SIGN_UP_REVAMP_GOOD_FRICTION_240625 = 'SIGN_UP_REVAMP_GOOD_FRICTION_240625';
